/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'मध्यरात', 'मध्यान्ह', 'बिहान',
      'अपरान्ह', 'साँझ', 'बेलुकी', 'रात'
    ],
    ,
  ],
  ,
  [
    '00:00', '12:00', ['04:00', '12:00'], ['12:00', '16:00'], ['16:00', '19:00'],
    ['19:00', '22:00'], ['22:00', '04:00']
  ]
];
